import React from 'react';

function PdfConfirmModal({
  show,
  onClose,
  onConfirm,
  title,
  message,
  isLoading,
}) {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-primary py-2">
            <h6 className="modal-title text-white m-0">
              <i className="bi bi-file-earmark-pdf me-2"></i>
              {title || 'Confirmar Geração de PDF'}
            </h6>
            <button
              type="button"
              className="btn-close btn-close-white shadow-sm p-2"
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center">
              <i
                className="bi bi-question-circle-fill text-primary me-3"
                style={{ fontSize: '2rem' }}
              ></i>
              <div>
                <p className="mb-1">
                  {message || 'Deseja gerar e abrir o relatório PDF?'}
                </p>
              </div>
            </div>

            {isLoading && (
              <div className="mt-3 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <div
                    className="spinner-border spinner-border-sm text-primary me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  <div>
                    <span className="text-muted">Gerando relatório PDF...</span>
                    <br />
                    <small className="text-muted">
                      Por favor, aguarde. O PDF será aberto automaticamente.
                    </small>
                  </div>
                </div>
                <div className="progress mt-2" style={{ height: '3px' }}>
                  <div
                    className="progress-bar progress-bar-striped progress-bar-animated"
                    role="progressbar"
                    style={{ width: '100%' }}
                  ></div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              <i className="bi bi-x-lg me-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  >
                    <span className="visually-hidden">Carregando...</span>
                  </div>
                  Gerando...
                </>
              ) : (
                <>
                  <i className="bi bi-file-earmark-pdf me-1"></i>
                  Gerar PDF
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfConfirmModal;
